import { render, staticRenderFns } from "./EmployeeSummaryBox.vue?vue&type=template&id=888a7f4e&scoped=true"
import script from "./EmployeeSummaryBox.vue?vue&type=script&lang=js"
export * from "./EmployeeSummaryBox.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSummaryBox.vue?vue&type=style&index=0&id=888a7f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888a7f4e",
  null
  
)

export default component.exports